<template>
  <vs-popup class="rm-price-details-popup"
            :title="'SUNDRY ITEM PRICE DETAILS - ' + priceDetails.sundry_item_code"
            @close="onClose()"
            :active.sync="open"
            :buttons-hidden="true">

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addItemToCart)" autocomplete="off">
          <vx-card no-shadow>
            <div class="vx-row mb-8">
              <div class="vx-col md:w-1/4 w-full md:mb-0">
                <ValidationProvider vid="quantity" name="quantity" :rules="'required|integer|moq:'+priceDetails.min_OQ" v-slot="{ errors }">
                  <small class="label">Quantity needed</small>
                  <vx-input-group class="">
                    <template slot="prepend">
                      <div class="prepend-text bg-warning">
                        <span>{{priceDetails.sold_in}}</span>
                      </div>
                    </template>
                    <vs-input  size="large" v-on:input="onTypeQuantity" v-model="createForm.quantity"  name="quantity" class="w-full" label=""/>
                  </vx-input-group>
                  <small class="label text-danger">{{errors[0]}}</small>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/4 w-full md:mb-0">
                <ValidationProvider vid="price" name="price" rules="required" v-slot="{ errors }">
                  <small class="label">Unit price</small>
                  <vx-input-group class="">
                    <template slot="prepend">
                      <div class="prepend-text bg-warning">
                        <span>{{ priceDetails.sundry_supplier_currency }}</span>
                      </div>
                    </template>
                    <vs-input size="large" readonly v-model="priceDetails.unit_price"   name="price" class=" required" label=""/>
                  </vx-input-group>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/4 w-full md:mb-0">
                <ValidationProvider vid="price" name="price" rules="required" v-slot="{ errors }">
                  <small class="label">Total best price</small>
                  <vx-input-group class="">
                    <template slot="prepend">
                      <div class="prepend-text bg-warning">
                        <span>{{ priceDetails.sundry_supplier_currency }}</span>
                      </div>
                    </template>
                    <vs-input size="large" readonly v-model="createForm.total"   name="price" class=" required" label=""/>
                  </vx-input-group>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/4 w-full md:mb-0">
                <small class="label">&nbsp</small>
                <vs-button id="sundry-item-price-popup" color="warning" button="submit" size="large" class="w-full">Add</vs-button>
              </div>
            </div>
            <div class="flex flex-wrap items-center justify-end mt-8">

            </div>

            <div class="vx-row">
              <div class="vx-col lg:w-1/2 w-full">
                <vs-table :hoverFlat="true" noDataText="">
                  <template>
                    <vs-tr>
                      <vs-td class="font-semibold">Supplier</vs-td>
                      <vs-td>{{ priceDetails.sundry_supplier}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="font-semibold">Sundry Item Code</vs-td>
                      <vs-td>{{priceDetails.sundry_item_code}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="font-semibold">Sundry Product Code</vs-td>
                      <vs-td>{{priceDetails.sundry_product_code}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="font-semibold">Sundry Product Name</vs-td>
                      <vs-td>{{priceDetails.sundry_product_name}}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
              <div class="vx-col lg:w-1/2 w-full">
                <vs-table :hoverFlat="true" noDataText="">
                  <template>
                    <vs-tr>
                      <vs-td class="font-semibold">Country Manufacture</vs-td>
                      <vs-td>{{priceDetails.country_manufacture}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="font-semibold">Min Order Qty</vs-td>
                      <vs-td>{{priceDetails.min_OQ}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="font-semibold">Quantity In Each Pack/Box</vs-td>
                      <vs-td>{{priceDetails.packaging_size}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="font-semibold">Sold In</vs-td>
                      <vs-td>{{priceDetails.sold_in}}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col lg:w-full w-full">
                <vs-table :hoverFlat="true" noDataText="">
                  <template>
                    <vs-tr>
                      <vs-td width="25%" class="font-semibold">Description</vs-td>
                      <vs-td>{{ priceDetails.description}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td width="25%" class="font-semibold">Additional Information</vs-td>
                      <vs-td>{{priceDetails.additional_information}}</vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td width="25%" class="font-semibold">Shipping Handling</vs-td>
                      <vs-td>
                          <vs-button target :href="priceDetails.shipping_handling" class="p-0"
                                     size="small" color="success" type="flat" icon-pack="feather" icon="icon-eye">
                            {{__nameSplitter(priceDetails.shipping_handling)}}
                          </vs-button>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>

          </vx-card>


        </form>
      </ValidationObserver>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SundrySupplierRepository = RepositoryFactory.get('sundry')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      createForm: {
        total: Number(0).toFixed(2),
        quantity: ''
      },
      priceDetails: {
        sundry_item_code: '',
        min_OQ: '',
        sold_in: '',
        packaging_size: '',
        unit_price: ''
      }
    }
  }

export default {
  name: 'SundrySupplierItemPriceShowPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (data) {
      try {
        await Object.assign(this.$data, initialState())
        this.open = true;
        this.$refs.form.reset();
        this.id = data.id
        this.priceDetails = data
      } catch (error) {

      }
    },
    onClose() {
      this.open = false
      this.$refs.form.reset();
    },
    async addItemToCart () {
      const vue = this;
      await this.$vs.loading({
        container: '#sundry-item-price-popup',
        scale: 0.45
      })
       try {
         const payload = {
           sundry_item_id: this.priceDetails.id,
           quantity: this.createForm.quantity
         }
         await SundrySupplierRepository.addItemToTheCart(payload)
         this.showSuccessMessage('Sundry item add to the cart')
         this.open = false;
         await vue.$parent.onlyRefreshData()
       }catch (e) {
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close('#sundry-item-price-popup > .con-vs-loading')
    },
    onTypeQuantity() {
      if (Number(this.priceDetails.min_OQ) <= Number(this.createForm.quantity)) {
        let total = Number(this.priceDetails.unit_price) * Number(this.createForm.quantity)
        this.createForm.total = Number(total).toFixed(2)
      }
      else {
        this.createForm.total = Number('0').toFixed(2)
      }
    },
  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .rm-price-details-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 60% !important;
  }


</style>
